import { render, staticRenderFns } from "./surveyDetail.vue?vue&type=template&id=3e31e1f2&scoped=true&"
import script from "./surveyDetail.vue?vue&type=script&lang=js&"
export * from "./surveyDetail.vue?vue&type=script&lang=js&"
import style0 from "./surveyDetail.vue?vue&type=style&index=0&id=3e31e1f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e31e1f2",
  null
  
)

export default component.exports